// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__d9-Qf","img":"Logo_img__E3gA6","placeHeader":"Logo_placeHeader__jzv7V","placeFooter":"Logo_placeFooter__SNVhn","placeMobileNav":"Logo_placeMobileNav__rqh-I"};